import { OverlayRef } from '@angular/cdk/overlay';
import { Observable, Subject } from 'rxjs';

export class CreditTopUpOverlayRef {
  private _onClose = new Subject<boolean>();
  public constructor(private _overlayRef: OverlayRef) {}

  public close(reload = false): void {
    this._overlayRef.dispose();
    this._onClose.next(reload);
    this._onClose.complete();
  }

  public observeClose(): Observable<boolean> {
    return this._onClose.asObservable();
  }
}
